module.exports = __webpack_public_path__ + "static/media/Avenir-Black.45a182ef.woff2";